export default "__VITE_ASSET__Bldt3Siq__"